<template>
    <v-col cols="12" sm="12" md="6" class="my-0">
        <v-card>
            <v-card-title class="secondary white--text pa-3" id="card-title">
            <div class="">
                <v-icon class="mr-3" color="white" >mdi-currency-gbp</v-icon>
                <span class="">Rightmove Settings</span>
            </div>
            </v-card-title>
            <p v-bind:class="{hidden: !this.getHasLettingsError()}" class="errorMessage">Only numeric characters and '.' can be submitted as a lettings fee amount</p>
            <p v-bind:class="{hidden: !this.getHasSalesError()}" class="errorMessage">Only numeric characters and '.' can be submitted as a sales fee amount</p>
            <v-simple-table>
                <template>
                    <tbody>
                        <tr>
                            <td class="">Lettings Fee Amount (£):</td>
                            <td class="text-center"><input class="centered-input" v-bind:class="{errorBorder: this.getHasLettingsError()}" style="width:90%" placeholder="Set lettings fee" v-model.lazy="lettingsFeeAmount" v-on:change="changeLettingsFee()"></td>
                        </tr>
                        <tr>
                            <td class="">Sales Fee Amount (£):</td>
                            <td class="text-center"><input class="centered-input" v-bind:class="{errorBorder: this.getHasSalesError()}" style="width:90%" placeholder="Set sales fee" v-model.lazy="salesFeeAmount" v-on:change="changeSalesFee()"></td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <p class="description">*Enter your monthly costs for Rightmove. These figures will be used to calculate your RoI from Rightmove on the <router-link to="/rightmoveanalytics">Rightmove Dashboard</router-link> for the given month. These figures need to be updated every month.</p>
        </v-card>
    </v-col>
</template>
<script>
export default {
  data() {
    return {
        hasLettingsError: false,
        hasSalesError: false
    }
  },
  methods: {
      getHasLettingsError(){
          return this.hasLettingsError;
      },
        getHasSalesError(){
          return this.hasSalesError;
      },
      formatNumber: function (value) {
        if (typeof value !== "number") {
                return value;
        }
            value = value.toLocaleString(
                this.$store.state.currencyData.LocaleCode,
                { minimumFractionDigits: 0 }
            );
        return value;
    },
    changeLettingsFee(){
        if(isNaN(parseFloat(this.$store.state.Rightmove.rightMoveLettingsFee.amount))){
            this.hasLettingsError = true;
        }
        else{
            if(this.$store.state.Rightmove.rightMoveLettingsFee.id !== 0){
                const payload =  {
                    id: this.$store.state.Rightmove.rightMoveLettingsFee.id,
                    amount: this.$store.state.Rightmove.rightMoveLettingsFee.amount
                }
                this.$store.dispatch('Rightmove/updateRightmoveLettingsFee', payload);
            }
            else{
                const payload = {
                    feeType: "lettings",
                    startDate: this.$store.state.reportMonthStart,
                    endDate: this.$store.state.reportMonthEnd,
                    amount: this.$store.state.Rightmove.rightMoveLettingsFee.amount
                }
                this.$store.dispatch('Rightmove/createRightmoveLettingsFee', payload);
            }
            this.hasLettingsError = false;
        }
    },
    changeSalesFee(){
        if(isNaN(parseFloat(this.$store.state.Rightmove.rightMoveSalesFee.amount))){
            this.hasSalesError = true;
        }
        else{
            if(this.$store.state.Rightmove.rightMoveSalesFee.id !== 0){
                const payload =  {
                    id: this.$store.state.Rightmove.rightMoveSalesFee.id,
                    amount: this.$store.state.Rightmove.rightMoveSalesFee.amount
                }
                this.$store.dispatch('Rightmove/updateRightmoveSalesFee', payload);
            }
            else{
                const payload = {
                    feeType: "sales",
                    startDate: this.$store.state.reportMonthStart,
                    endDate: this.$store.state.reportMonthEnd,
                    amount: this.$store.state.Rightmove.rightMoveSalesFee.amount
                }
                this.$store.dispatch('Rightmove/createRightmoveSalesFee', payload);
            }
            this.hasSalesError = false;
        }
    },
  },
  computed: {
        lettingsFeeAmount: {
          get(){
            return this.formatNumber(this.$store.state.Rightmove.rightMoveLettingsFee.amount);
          },
          set(newValue){
              this.$store.state.Rightmove.rightMoveLettingsFee.amount = newValue;
          }
        },
       salesFeeAmount: {
          get(){
            return this.formatNumber(this.$store.state.Rightmove.rightMoveSalesFee.amount);
          },
          set(newValue){
              this.$store.state.Rightmove.rightMoveSalesFee.amount = newValue;
          }
        }
  },
  mounted () {
  },
  created(){
        this.$store.dispatch("Rightmove/getRightmoveSalesFee");
        this.$store.dispatch("Rightmove/getRightmoveLettingsFee");
  },
  watch: {
    '$store.state.reportMonth': function (){
        this.$store.dispatch("Rightmove/getRightmoveSalesFee");
        this.$store.dispatch("Rightmove/getRightmoveLettingsFee");
    }
  }
}
</script>
<style scoped>
.description{
    font-size:10px;
}
</style>
